import { render, staticRenderFns } from "./ClientBillingForm.vue?vue&type=template&id=88fd5b84&scoped=true&"
import script from "./ClientBillingForm.vue?vue&type=script&lang=js&"
export * from "./ClientBillingForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientBillingForm.vue?vue&type=style&index=0&id=88fd5b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd5b84",
  null
  
)

export default component.exports